import React, {useContext, useMemo, useState} from 'react';
import {DashboardLayout} from 'components';
import Navbar from './components/Navbar';
import RuleEditor from './editor/RuleEditor';
import PreviewScreen from './components/PreviewScreen';
import {addNewRule, deleteRule} from './hooks/ruleUtils';
import {useFlowData} from '../EditProcess/hooks/useFlowData';
import {CreditCheckContext} from '../../../../helpers/context/CreditCheckContext';

const defaultRule = [
  {
    id: 1,
    name: 'Rule 1',
    groups: [
      {
        id: 1,
        conditionType: 'and',
        conditions: [{id: 1, parent: '', field: '', operator: '', value: ''}],
      },
    ],
  },
];

function UpdatedEditProcess() {
  const [isEditorOpen, setIsEditorOpen] = useState(true);
  const [ruleListLoading, setRuleListLoading] = useState(false);
  const FLowData = useFlowData();
  const {
    set: {setCurrentActiveRule},
  } = useContext(CreditCheckContext);

  const toggleEditor = () => {
    setIsEditorOpen(!isEditorOpen);
  };

  const handleAddNewRule = position => {
    addNewRule(
      FLowData.rules,
      FLowData.setRules,
      position,
      setCurrentActiveRule,
    );
  };

  const handleDeleteRule = ruleId => {
    deleteRule(FLowData.rules, FLowData.setRules, ruleId);
  };

  const clearedRules = () => FLowData.setRules(defaultRule);

  const isListLoading = useMemo(
    () =>
      ruleListLoading ||
      FLowData.isSavingListAssociation ||
      FLowData.isFetchingListAssociation,
    [
      FLowData.isFetchingListAssociation,
      FLowData.isSavingListAssociation,
      ruleListLoading,
    ],
  );

  return (
    <DashboardLayout
      bg="bg-[#DAE4F4]"
      fullScreen
      topPadding="pt-0 "
      leftMargin="ml-0"
      xlLeftMargin="xl:ml-0"
      xlRightPadding="sm:pr-0 !pr-0"
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">Fraud Detection</p>
      }
    >
      {isListLoading && (
        <div className="absolute inset-0 z-30 bg-[#c8d3dc90]/10  pointer-events-auto backdrop-blur-[1px] " />
      )}
      <Navbar
        isListLoading={isListLoading}
        rules={FLowData.rules}
        clearProcess={clearedRules}
      />
      <div className="relative w-full flex">
        <RuleEditor
          isOpen={isEditorOpen}
          toggleEditor={toggleEditor}
          rules={FLowData.rules}
          setRules={FLowData.setRules}
        />
        <PreviewScreen
          isEditorOpen={isEditorOpen}
          rules={FLowData.rules}
          addNewRule={handleAddNewRule}
          deleteRule={handleDeleteRule}
          setRuleListLoading={setRuleListLoading}
          isListLoading={isListLoading}
        />
      </div>
    </DashboardLayout>
  );
}

export default UpdatedEditProcess;
